module.exports = __webpack_public_path__ + "img/final_banner.4405adb9.jpg";